/**
 * Marker 선택 Modal
 */

import { _ } from 'core-js'

export default {
  name: 'BriqueChartModalChartType',
  inheritAttrs: false, // 부모 Component에서 지정한 Element 속성을 무시 - vue 파일의 다음 구분 참조(v-bind="$attrs", v-on="$listeners"
  props: {
    visible: {
      type: Boolean,
      default: true,
      required: false
    },
    parentChartData: {
      type: Array,
      required: true
    },
    seriesName: {
      type: String,
      default: '',
      required: true
    },
    beforeType: {
      type: String,
      default: '',
      required: true
    },
    beforeMode: {
      type: String,
      default: '',
      required: true
    },
    beforeFill: {
      type: String,
      default: '',
      required: true
    },
    beforeOrientation: {
      type: String,
      default: '',
      required: true
    }
  },
  computed: {
  },
  methods: {
    /**
    * 확인 버튼 클릭시 처리
    * @param {Object} returnObject returnObject.visible을 true로 하면 모달창이 닫히지 않는다.
    */
    onClickConfirmButton (returnObject) {
      this.$emit('click-confirm-button-in-modal-chart-type', returnObject, this.seriesName, this.data)
    },

    /**
    * 취소 버튼 클릭시 처리
    * @param {Object} returnObject returnObject.visible을 true로 하면 모달창이 닫히지 않는다.
    */
    onClickCancelButton (returnObject) {
    }
  }, // end - methods
  created () {
  },
  watch: {
    visible () {
      if (this.visible === false) return
      let beforeType = _.isEmpty(this.beforeType) ? 'none' : this.beforeType
      let beforeMode = _.isEmpty(this.beforeMode) ? 'none' : this.beforeMode
      let beforeFill = _.isEmpty(this.beforeFill) ? 'none' : this.beforeFill
      let beforeOrientation = _.isEmpty(this.beforeOrientation) ? 'none' : this.beforeOrientation
      let filterType = this.types.filter(t => t.type === beforeType && t.mode === beforeMode && t.fill === beforeFill && t.orientation === beforeOrientation)
      if (filterType.length > 0) {
        this.data = filterType[0]
      }
    }
  },
  data () {
    return {
      data: {
        type: '',
        mode: '',
        fill: '',
        orientation: ''
      },
      types: [
        {
          type: 'none',
          mode: 'lines',
          fill: 'none',
          orientation: 'none',
          name: this.$t('fdc.CHART_COMPONENT.LABEL.CHART_TYPE.LINE'),
          chartSymbol: `
            <svg viewBox="0 0 46 46">
              <g fill="none">
                <path d="M0 0h46v46H0z"/>
                <path stroke="#25fdfc" d="M5.087 39l9.391-12.913 8.218 7.043L37.957 12" stroke-miterlimit="10" stroke-width="2.348"/>
                <path stroke="#1d9bfb" d="M12.13 37.826l11.74-15.261 8.217 7.044 8.217-11.739" stroke-miterlimit="10" stroke-width="2.348"/>
              </g>
            </svg>
          `
        },
        {
          type: 'none',
          mode: 'markers',
          fill: 'none',
          orientation: 'none',
          name: this.$t('fdc.CHART_COMPONENT.LABEL.CHART_TYPE.SCATTER'),
          chartSymbol: `
            <svg viewBox="0 0 46 46">
              <path fill="none" d="M0 0h46v46H0z"/>
              <circle cx="13" cy="32" r="3" fill="#1d9bfb"/>
              <circle cx="21" cy="27" r="3" fill="#25fdfc"/>
              <circle cx="23" cy="18" r="3" fill="#1d9bfb"/>
              <circle cx="32" cy="24" r="3" fill="#25fdfc"/>
              <circle cx="32" cy="11" r="3" fill="#25fdfc"/>
            </svg>
          `
        },
        {
          type: 'bar',
          mode: 'none',
          fill: 'none',
          orientation: 'none',
          name: this.$t('fdc.CHART_COMPONENT.LABEL.CHART_TYPE.BAR'),
          chartSymbol: `
            <svg viewBox="0 0 46 46">
              <path fill="none" d="M0 0h46v46H0z"/>
              <path fill="#25fdfc" d="M7 28h6v12H7z"/>
              <path fill="#1d9bfb" d="M32 28h6v12h-6zM15 10h6v30h-6z"/>
              <path fill="#25fdfc" d="M24 20h6v20h-6z"/>
            </svg>
          `
        },
        {
          type: 'bar',
          mode: 'none',
          fill: 'none',
          orientation: 'h',
          name: this.$t('fdc.CHART_COMPONENT.LABEL.CHART_TYPE.VERTICAL_BAR'),
          chartSymbol: `
            <svg viewBox="0 0 60 60" style="-ms-transform: rotate(90deg);-webkit-transform: rotate(90deg);transform: rotate(90deg);">
              <path fill="none" d="M0 0h46v46H0z"></path>
              <path fill="#25fdfc" d="M7 28h6v27H7z"></path>
              <path fill="#1d9bfb" d="M32 28h6v28h-6zM15 10h6v45h-6z"></path>
              <path fill="#25fdfc" d="M24 20h6v35h-6z"></path>
              <path fill="#25fdfc" d="M41 20h6v36h-6z"></path>
            </svg>
          `
        },
        {
          type: 'none',
          mode: 'none',
          fill: 'tozeroy',
          orientation: 'none',
          name: this.$t('fdc.CHART_COMPONENT.LABEL.CHART_TYPE.AREA'),
          chartSymbol: `
            <svg viewBox="0 0 46 46">
              <path fill="none" d="M0 0h46v46H0z"/>
              <path fill="#25fdfc" d="M38 39V23l-11 4-9-3-11 3v12h31z"/>
              <path fill="#1d9bfb" d="M38 21l-11 4-9-3-11 3V14l14 5L38 7v14z"/>
            </svg>
          `
        },
        {
          type: 'pie',
          mode: 'none',
          fill: 'none',
          orientation: 'none',
          name: this.$t('fdc.CHART_COMPONENT.LABEL.CHART_TYPE.PIE'),
          chartSymbol: `
            <svg viewBox="0 0 46 46">
              <path fill="none" d="M0 0h46v46H0z"/>
              <path d="M23 23l-10.725 8.999A14 14 0 0 0 37 23z" fill="#1d9bfb"/>
              <path d="M23 23h14A14 14 0 0 0 25.431 9.213zm0 0H9a14 14 0 0 0 3.275 8.999zm0 0l2.431 13.787A14 14 0 0 0 32 33.725z" fill="#25fdfc"/>
              <path d="M23 23l2.431-13.787A14 14 0 0 0 9 23z" fill="#1d9bfb"/>
              <circle cx="23" cy="23" r="6" fill="#fff"/>
            </svg>
          `
        }
      ],
      distTypes: [
        {
          type: 'histogram',
          mode: 'none',
          fill: 'none',
          orientation: 'none',
          name: this.$t('fdc.CHART_COMPONENT.LABEL.CHART_TYPE.HISTOGRAM'),
          chartSymbol: `
            <svg viewBox="0 0 46 46">
              <path fill="none" d="M0 0h46v46H0z"/>
              <path fill="#1d9bfb" d="M7 20h8v20H7z"/>
              <path fill="#25fdfc" d="M32 28h8v12h-8zM15 16h9v24h-9z"/>
              <path fill="#1d9bfb" d="M24 20h8v20h-8z"/>
            </svg>
          `
        },
        {
          type: 'histogram2d',
          mode: 'none',
          fill: 'none',
          orientation: 'none',
          name: this.$t('fdc.CHART_COMPONENT.LABEL.CHART_TYPE.HISTOGRAM_2D'),
          chartSymbol: `
            <svg viewBox="0 0 46 46">
              <path fill="none" d="M0 0h46v46H0z"/>
              <path fill="#1d9bfb" d="M32 20h6v6h-6zm-12-6h6v6h-6zm-6 6h6v6h-6zm0 12h6v6h-6zm6 0h6v6h-6zm12 0h6v6h-6zm-6-12h6v6h-6z"/>
              <path fill="#25fdfc" d="M26 14h6v6h-6zm6 0h6v6h-6zm-12 6h6v6h-6zM8 20h6v6H8z"/>
              <path fill="#1d9bfb" d="M14 14h6v6h-6z"/>
              <path fill="#25fdfc" d="M8 14h6v6H8z"/>
              <path fill="#1d9bfb" d="M26 26h6v6h-6zM8 26h6v6H8z"/>
              <path fill="#25fdfc" d="M20 26h6v6h-6zm12 0h6v6h-6zm-18 0h6v6h-6z"/>
              <path fill="#1d9bfb" d="M26 8h6v6h-6zM8 8h6v6H8z"/>
              <path fill="#25fdfc" d="M20 8h6v6h-6zm12 0h6v6h-6zM14 8h6v6h-6zM8 32h6v6H8zm18 0h6v6h-6z"/>
              <circle cx="29" cy="29" r="2" fill="#fff"/>
              <circle cx="17" cy="23" r="2" fill="#fff"/>
              <circle cx="17" cy="35" r="2" fill="#fff"/>
              <circle cx="29" cy="23" r="2" fill="#fff"/>
              <circle cx="23" cy="17" r="2" fill="#fff"/>
              <path fill="none" stroke="#fff" d="M29 11l1.5-1.5M29 11l-1.5-1.5M29 11l1.5 1.5M29 11l-1.5 1.5M35 23l1.5-1.5M35 23l-1.5-1.5M35 23l1.5 1.5M35 23l-1.5 1.5M23 35l1.5-1.5M23 35l-1.5-1.5M23 35l1.5 1.5M23 35l-1.5 1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          `
        },
        {
          type: 'histogram2dcontour',
          mode: 'none',
          fill: 'none',
          orientation: 'none',
          name: this.$t('fdc.CHART_COMPONENT.LABEL.CHART_TYPE.CONTOUR_HISTOGRAM_2D'),
          chartSymbol: `
            <svg viewBox="0 0 46 46">
              <path fill="none" d="M0 0h46v46H0z"/>
              <path d="M40.616 19.3a16.387 16.387 0 0 0-1.352-3.904 9.836 9.836 0 0 0-4.225-4.015c-6.17-3.152-13.563-4.731-20.021-1.298a23.665 23.665 0 0 0-4.74 3.47 14.357 14.357 0 0 0-3.28 3.934c-1.636 3.205-.982 6.997-.015 10.433a7.81 7.81 0 0 0 1.083 2.555 8.344 8.344 0 0 0 2.63 2.1c2.611 1.526 5.352 2.845 8.089 4.161a13.223 13.223 0 0 0 2.59 1.028 11.867 11.867 0 0 0 3.048.229 8.678 8.678 0 0 0 3.538-.623 8.95 8.95 0 0 0 2.162-1.622l6.115-5.645c2.223-2.053 4.584-4.37 4.83-7.288a10.951 10.951 0 0 0-.452-3.515zm-5.174 2.942c-.29 1.988-1.825 3.679-3.153 4.984a88.579 88.579 0 0 1-3.648 3.367 5.915 5.915 0 0 1-1.32.94 5.617 5.617 0 0 1-2.098.423 7.835 7.835 0 0 1-1.807-.076 9.038 9.038 0 0 1-1.8-.557 31.794 31.794 0 0 1-5.487-2.889 7.104 7.104 0 0 1-1.758-1.487q-.114-.146-.212-.3a5.426 5.426 0 0 1-.622-1.396 11.172 11.172 0 0 1-.476-3.496 6.775 6.775 0 0 1 .752-2.988 9.108 9.108 0 0 1 2.07-2.44 13.848 13.848 0 0 1 3.042-2.08 11.145 11.145 0 0 1 1.363-.556c3.693-1.236 7.762-.478 11.257 1.23a7.12 7.12 0 0 1 2.765 2.381 6.918 6.918 0 0 1 .995 2.566 6.94 6.94 0 0 1 .137 2.374z" fill="#25fdfc" stroke="#1d9bfb" stroke-miterlimit="10" stroke-width="2"/>
              <path d="M34.31 17.302a7.12 7.12 0 0 0-2.765-2.382c-3.495-1.709-7.564-2.466-11.257-1.23a11.145 11.145 0 0 0-1.363.556 13.848 13.848 0 0 0-3.043 2.081 9.108 9.108 0 0 0-2.07 2.44 6.775 6.775 0 0 0-.75 2.987 11.172 11.172 0 0 0 .475 3.496 5.426 5.426 0 0 0 .622 1.397q.099.153.212.3a7.104 7.104 0 0 0 1.758 1.486 31.794 31.794 0 0 0 5.486 2.889 9.038 9.038 0 0 0 1.801.558 7.835 7.835 0 0 0 1.807.075 5.617 5.617 0 0 0 2.099-.423 5.915 5.915 0 0 0 1.319-.94 88.299 88.299 0 0 0 3.648-3.366c1.328-1.306 2.863-2.996 3.153-4.985a6.94 6.94 0 0 0-.137-2.373 6.918 6.918 0 0 0-.995-2.566z" fill="#25fdfc" stroke="#1d9bfb" opacity=".25" stroke-miterlimit="10" stroke-width="2"/>
              <path d="M25.457 25.996c-1.787.083-3.494-1.142-4.914-2.724a2.032 2.032 0 0 1-.452-.69 2.44 2.44 0 0 1 .028-1.4 3.985 3.985 0 0 1 1.368-2.08 4.888 4.888 0 0 1 1.922-.854 6.99 6.99 0 0 1 5.948.96c1.604 1.233-.197 4.086-1.018 5.142a3.975 3.975 0 0 1-2.882 1.646z" fill="#fff" stroke="#1d9bfb" stroke-miterlimit="10" stroke-width="2"/>
            </svg>
          `
        }
      ]
    } // end - data return
  } // end-data
}
